import React, { Component, Fragment } from 'react'
import { Input, Button, message } from 'hljd'
import styles from './formStyle'
import Api from '@api/xiu_yan/homeApi'
import { isPhone } from '@hlj/hlj-utils'
class SmsCode extends Component {
  constructor(props) {
    super(props)

    this.state = {
      codeVisible: false,
      count: 60
    }
    this.interval = null
  }

  getCode = async () => {
    let contact_phone = this.props.getFieldsValue(['contact_phone'])
      .contact_phone
    let image_code = this.props.getFieldsValue(['image_code']).image_code

    if (!contact_phone) {
      return message.warning('手机号不能为空！')
    }
    if (!isPhone(contact_phone)) {
      return message.warning('请正确输入号码！')
    }
    if (!image_code) {
      return message.warning('验证码不能为空！')
    }

    let { msg } = await Api.checkMsgCode({ image_code, phone: contact_phone })
    if (msg == 'success') {
      message.success('发送成功！')
      this.setState({ codeVisible: true })

      this.interval = setInterval(() => {
        this.setState({ count: this.state.count - 1 })
        if (this.state.count < 1) {
          this.setState({ codeVisible: false, count: 60 })
          window.clearInterval(this.interval)
          this.interval = null
        }
      }, 1000)
    } else {
      return message.warning(msg)
    }
  }

  componentWillUnmount() {
    window.clearInterval(this.interval)
    this.interval = null
  }

  render() {
    const { value, onChange } = this.props
    const { codeVisible, count } = this.state
    return (
      <Fragment>
        <Input
          style={{ width: 252 }}
          value={value}
          onChange={value => onChange(value)}
        />
        <Button
          type="primary"
          className={styles.codeBtn}
          onClick={this.getCode}
          disabled={codeVisible}
        >
          {!codeVisible ? '获取' : count + 's'}
        </Button>
      </Fragment>
    )
  }
}
export default SmsCode
